import _Dialog from "@material-ui/core/esm/Dialog";
import React from 'react';
import classnames from 'classnames';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { variables } from 'swag-client-common/styles/variables-js';
import { Title } from './components/title';
import Content from './components/content';
import Footer from './components/footer';
import CSSClasses from './popup-dialog.scss';
const styles = () => {
  return createStyles({
    paper: {
      position: 'relative',
      borderRadius: variables.popupBorderRadius,
      maxWidth: 730,
      padding: '0 30px',
      backgroundColor: variables.colorBackgroundLightGray,
      overflowY: 'initial'
    }
  });
};

// default transition values stored here: https://next.material-ui.com/customization/transitions/
export const DEFAULT_POPUP_ENTER_TRANSITION = 225;
export const DEFAULT_POPUP_EXIT_TRANSITION = 195;
const DEFAULT_POPUP_TRANSITION = {
  enter: DEFAULT_POPUP_ENTER_TRANSITION,
  exit: DEFAULT_POPUP_EXIT_TRANSITION
};
const PopupDialogComponent = ({
  open,
  title = null,
  content = null,
  footer = null,
  children,
  dataPopup = '',
  contentClass = '',
  titleHeader = '',
  closeClass = '',
  popupClassName = '',
  classes = null,
  titleClasses = null,
  footerClasses = null,
  showCloseButton = true,
  fullScreen = false,
  disableScrollLock = true,
  TransitionProps = {},
  onClose = () => {
    /* empty */
  },
  transitionDuration = DEFAULT_POPUP_TRANSITION,
  keepMounted = false,
  closeStyles
}) => {
  return /*#__PURE__*/React.createElement(_Dialog, {
    open: open,
    onClose: onClose,
    classes: classes,
    scroll: "body",
    className: classnames(CSSClasses.popupDialog, popupClassName),
    fullScreen: fullScreen,
    transitionDuration: transitionDuration,
    disableScrollLock: disableScrollLock,
    TransitionProps: TransitionProps,
    keepMounted: keepMounted
  }, /*#__PURE__*/React.createElement(Title, {
    classes: titleClasses,
    showCloseButton: showCloseButton,
    onClose: onClose,
    titleHeader: classnames(CSSClasses.titleHeader, titleHeader),
    closeClass: closeClass,
    closeStyles: closeStyles
  }, title), /*#__PURE__*/React.createElement(Content, {
    className: classnames(CSSClasses.content, contentClass),
    "data-popup": dataPopup
  }, children || content), footer && /*#__PURE__*/React.createElement(Footer, {
    classes: footerClasses
  }, footer));
};
export const PopupDialog = withStyles(styles)(PopupDialogComponent);